import React from "react";
import FileDownload from "js-file-download";
import { connect } from "react-redux";
import moment from "moment";
import { Button } from "reactstrap";
import { Link } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars";
import Loading from "../../../system/components/Loading";
import ReactTable from "react-table";
import checkboxHOC from "react-table/lib/hoc/selectTable";
import Aux from "../../../system/containers/Aux";
import Toolbar from "./components/Toolbar";
import PageHeader from "../../../system/components/PageHeader";
import { WrappedTable, filterString } from "../../../system/containers/Table";
import Http from "../../../system/utils/Http";

import { actionCreators } from "../../../store/enquiries/deal";

const CheckboxTable = checkboxHOC(ReactTable);
const columns = [
  {
    accessor: "full_name",
    Header: "Full Name",
    filterMethod: filterString,
    Cell: (props) => (
      <a href={"/enquiries/deal-enquiry/edit/" + props.original.id}>
        {props.value}
      </a>
    ),
  },
  {
    accessor: "deal_name",
    Header: "Deal Name",
    filterMethod: filterString,
    Cell: (props) => (
      <a href={"/enquiries/deal-enquiry/edit/" + props.original.id}>
        {props.value}
      </a>
    ),
  },
  {
    accessor: "created_at",
    Header: "Created",
    filterable: false,
    Cell: (props) => moment(props.value.date).format("DD/MM/YYYY"),
  },
  {
    accessor: null,
    Header: null,
    filterable: false,
    Cell: (props) => (
      <Link to={"/enquiries/deal-enquiry/edit/" + props.original.id}>
        <Button outline size="sm">
          Edit
        </Button>
      </Link>
    ),
  },
];

class List extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: [],
    };
  }

  componentWillMount() {
    this.props.dispatch(actionCreators.fetchAll());
  }

  remove() {
    let items = this.props.selected;
    if (items.length === 0) {
      return alert("You have not selected any entries");
    }
    const result = window.confirm(
      "Are you sure you want to remove these entries?"
    );
    if (result) {
      this.props.dispatch(actionCreators.delete(items));
    }
  }

  export = () => {
    let items = this.props.selected;
    if (items.length === 0) {
      return alert("You haven't selected any enquiries");
    }
    const result = window.confirm(
      "Are you sure these are the enquiries you want to export"
    );

    if (result) {
      Http.post("/deal-enquiry/export", {
        ids: items,
      })
        .then((res) => {
          FileDownload(res.data, "deal-enquiry-report.csv");
        })
        .catch((err) => {
          console.error(err);
        });
    }
  };

  render() {
    const { data, permissions, checkboxProps, loading } = this.props;
    if (loading) {
      return <Loading />;
    }
    return (
      <Aux>
        <PageHeader title="Deal Enquiries" />
        <Toolbar
          permissions={permissions}
          createLink={"/enquiries/deal-enquiry/create"}
          total={data.length}
          handleDelete={() => this.remove()}
          export={() => this.export()}
        />
        <Scrollbars
          style={{ width: "100%", height: "100%", paddingBottom: "100px" }}
        >
          <CheckboxTable
            ref={(r) => (this.checkboxTable = r)}
            data={data}
            keyField="id"
            showPaginationBottom
            filterable
            columns={columns}
            loading={data.loading}
            defaultPageSize={20}
            style={{
              height: "100vh",
            }}
            className="-striped -highlight"
            {...checkboxProps}
          />
        </Scrollbars>
      </Aux>
    );
  }
}

function mapStateToProps(store) {
  return {
    permissions: store.auth.permissions,
    data: store.enquiriesDeals.list,
    loading: store.enquiriesDeals.loading,
  };
}

const WrapTable = WrappedTable(List);

export default connect(mapStateToProps)(WrapTable);



// WEBPACK FOOTER //
// ./src/containers/Enquiries/DealEnquiry/List.jsx